import { getInMeetingExperienceProxyApiUrl, getProxyApiUrl } from 'in-meeting-experience-ui-components/utils/general';
import noAuthClient from '../../utils/apiClient';
const API_BASE = `${getProxyApiUrl()}/crm/v3/objects`;
const API_PROXY_BASE = getInMeetingExperienceProxyApiUrl();
export const fetchAssociationSectionList = ({
  callObjectId,
  toObjectType,
  setSkipRefresh
}) => noAuthClient.get(`${API_BASE}/calls/${callObjectId}/associations/${toObjectType}`, {
  setSkipRefresh
});
export const associateObject = ({
  objectId,
  objectType,
  toObjectId,
  associationType
}) => noAuthClient.put(`${API_BASE}/${objectType}/${objectId}/associations/call/${toObjectId}/${associationType}`);
export const removeAssociationObject = ({
  objectId,
  objectType,
  toObjectId,
  associationType
}) => noAuthClient.delete(`${API_BASE}/${objectType}/${objectId}/associations/call/${toObjectId}/${associationType}`);
export const updateAssociationObject = ({
  objectId,
  objectType,
  data
}) => noAuthClient.patch(`${API_BASE}/${objectType}/${objectId}`, {
  data: {
    properties: data
  }
});
export const getCreatorAssociationPropertiesDefinitions = objectTypeId => noAuthClient.get(`${API_PROXY_BASE}/v1/associations/definitions/${objectTypeId}`);